import { useStoryblokApi, useStoryblokBridge } from "@storyblok/vue";
import { computed, watch } from "vue";
import { useAsyncData } from "#app";
const stableStringify = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = sortedKeys.reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
  return JSON.stringify(sortedObj);
};
export async function useAsyncStoryblok(url, options) {
  const storyblokApiInstance = useStoryblokApi();
  const { api, bridge, ...rest } = options;
  const uniqueKey = `${stableStringify(api)}${url}`;
  const result = await useAsyncData(uniqueKey, () => storyblokApiInstance.get(`cdn/stories/${url}`, api), rest);
  if (import.meta.client) {
    watch(result.data, (newData) => {
      if (newData?.data.story && newData.data.story.id) {
        useStoryblokBridge(newData.data.story.id, (evStory) => {
          newData.data.story = evStory;
        }, bridge);
      }
    }, {
      immediate: true
    });
  }
  return {
    data: result.data,
    pending: result.pending,
    error: result.error,
    refresh: result.refresh,
    execute: result.execute,
    clear: result.clear,
    story: computed(() => result.data.value?.data.story)
  };
}
;
